import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@equine-ui-nx/account';
import { MatSnackBar } from '@angular/material/snack-bar';

export const authGuard: CanActivateFn = (route, state) => {
  // Use dependency injection to get an instance of the AuthService
  const authService = inject(AuthService);
  const router: Router = inject(Router);
  const _snackBar = inject(MatSnackBar);
  // Check if the user is logged in using the AuthService
  if (authService.isAuthenticated()) {
    return true; // If logged in, allow access to the route
  } else {
    authService.setRequestedUrl(window.location.href);
    _snackBar.open('You dont have access for this route!', 'close', {
      duration: 1000,
      panelClass: ['error-snackbar']
    });
    return router.createUrlTree(['/account/login']);
    return false; // If not logged in, deny access to the route
  }
};
